export const FINAL_DETAILS_STEP_NUMBER = 19;
export const PAYMENT_DETAILS_STEP_NUMBER = 20;

export function resolveEmailChangeResumeStep(
  savedStep,
  minimumStep = FINAL_DETAILS_STEP_NUMBER,
) {
  const parsedSaved = Number.parseInt(savedStep, 10);
  const parsedMinimum = Number.parseInt(minimumStep, 10);
  const floor = Number.isFinite(parsedMinimum)
    ? parsedMinimum
    : FINAL_DETAILS_STEP_NUMBER;
  if (!Number.isFinite(parsedSaved)) return floor;
  return Math.max(parsedSaved, floor);
}
